import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';

import {
  Dialog,
  DialogActions,
  DialogContent,
  KeyIcon,
  Stack,
  styled,
  Button,
  Typography,
} from '@datanomik/commons-ui';

import { UserForbidLine } from '@datanomik/commons-ui/icons';

import { useAppContext } from '@/contexts/app';
import { useWorkspaceContext } from '@/contexts/workspace';

import { styles } from './styles';

const ForbiddenRaw = ({ className }) => {
  const { handleResetStatus } = useAppContext();
  const { workspace: { redirectHome } } = useWorkspaceContext();

  const handleRedirect = () => {
    handleResetStatus();
    redirectHome();
  };

  return (
    <Dialog
      className={className}
      open
      maxWidth="xs"
    >
      <DialogContent>
        <Stack p="20px" gap="20px" alignItems="center">
          <KeyIcon size="xlarge" color="neutral">
            <UserForbidLine />
          </KeyIcon>

          <Typography fontWeight="500" align="center">
            {t("It appears you don't have permissions to access this page")}
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={handleRedirect}
          fullWidth
        >
          {t('Back to home page')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const Forbidden = styled(ForbiddenRaw)(styles);

ForbiddenRaw.propTypes = {
  className: PropTypes.string,
};

Forbidden.propTypes = ForbiddenRaw.propTypes;

export default Forbidden;
